/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchRuleState
 */
export interface SearchRuleState {
    /**
     * 
     * @type {string}
     * @memberof SearchRuleState
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof SearchRuleState
     */
    disabled?: boolean;
}

export function SearchRuleStateFromJSON(json: any): SearchRuleState {
    return SearchRuleStateFromJSONTyped(json, false);
}

export function SearchRuleStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRuleState {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
    };
}

export function SearchRuleStateToJSON(value?: SearchRuleState | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
    };
}


